import { formatDistanceToNow } from "date-fns";
import { SkillsQuery } from "generated-graphql/graphql";
import { OmnisearchGridColDef } from "hooks/useOmnisearchDatagrid";

import { SkillAccessChip } from "../SkillAccess/SkillAccessChip";
import {
  SKILL_AUDIENCE_OPTIONS,
  SKILL_AUDIENCE_TOKENS,
  SKILL_SCOPE_OPTIONS,
  SKILL_SCOPE_TOKENS,
} from "../SkillAccess/skillAccessTokens";
import { SkillNameCell } from "./SkillNameCell";

export type SkillRow = SkillsQuery["skills"]["items"][number];

const SCOPE_OPTIONS = SKILL_SCOPE_OPTIONS.map(({ value, label }) => ({ value, label }));
const AUDIENCE_OPTIONS = SKILL_AUDIENCE_OPTIONS.map(({ value, label }) => ({ value, label }));

export const SKILLS_GRID_COLUMNS: OmnisearchGridColDef<SkillRow>[] = [
  {
    field: "displayName",
    headerName: "Skill",
    flex: 1.6,
    minWidth: 220,
    filterable: false,
    renderCell: (params) => <SkillNameCell skill={params.row} />,
  },
  {
    field: "audience",
    headerName: "Audience",
    width: 130,
    type: "singleSelect",
    valueOptions: [...AUDIENCE_OPTIONS],
    filterKeyType: "enum",
    enumValues: AUDIENCE_OPTIONS.map((option) => option.value),
    enumPresentationFunction: (value) =>
      AUDIENCE_OPTIONS.find((option) => option.value === value)?.label ?? value,
    renderCell: (params) => <SkillAccessChip token={SKILL_AUDIENCE_TOKENS[params.row.audience]} />,
  },
  {
    field: "scope",
    headerName: "Scope",
    width: 160,
    type: "singleSelect",
    valueOptions: [...SCOPE_OPTIONS],
    filterKeyType: "enum",
    enumValues: SCOPE_OPTIONS.map((option) => option.value),
    enumPresentationFunction: (value) =>
      SCOPE_OPTIONS.find((option) => option.value === value)?.label ?? value,
    renderCell: (params) => <SkillAccessChip token={SKILL_SCOPE_TOKENS[params.row.scope]} />,
  },
  {
    field: "updatedAt",
    headerName: "Updated",
    width: 120,
    filterable: false,
    valueGetter: (_value, row) => (row.updatedAt ? new Date(row.updatedAt) : null),
    valueFormatter: (value: Date | null) =>
      value ? formatDistanceToNow(value, { addSuffix: true }) : "",
  },
];
